import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { FileProviderViewState, FileSelectionFilter } from 'owa-fileprovider-store';
import { getFileProviders } from 'owa-fileprovider-store/lib/selectors/getFileProviders';
import getSupportedFileSelectionFilters from 'owa-fileprovider-store/lib/utils/getSupportedFileSelectionFilters';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';

export default function getAddedProviders(
    fileSelectionFilter?: FileSelectionFilter
): FileProviderViewState[] {
    const addedFileProviders = getFileProviders();
    const hideOneDrive = shouldHideOneDrive();

    const filteredAddedFileProviders = addedFileProviders.filter(
        filterForFileProviderSupportingSelectionFilter(fileSelectionFilter, hideOneDrive)
    );
    return sortFileProvidersViewState(filteredAddedFileProviders);
}

export function shouldHideOneDrive() {
    const configuration = getUserConfiguration();
    return (
        !!configuration.AttachmentPolicy &&
        !configuration.AttachmentPolicy.AttachmentDataProviderAvailable &&
        configuration.AttachmentPolicy.GroupsOneDriveDataProviderAvailable
    );
}

function filterForFileProviderSupportingSelectionFilter(
    fileSelectionFilter: FileSelectionFilter,
    hideOneDrive: boolean
): (viewState: FileProviderViewState) => boolean {
    return (viewState: FileProviderViewState) => {
        // If the user has a license for groups, but not for OneDrive, we filter out the OneDrive provider.
        // We are relying on server sending this OneDrive provider without a name if it should not show up
        if (hideOneDrive && !viewState.name) {
            return false;
        }
        const isNoneFilter =
            fileSelectionFilter === FileSelectionFilter.None || !fileSelectionFilter;

        // Return true if it is a None filter, if not then check if the file provider supports that filter
        return (
            isNoneFilter ||
            getSupportedFileSelectionFilters(viewState.type).indexOf(fileSelectionFilter) !== -1
        );
    };
}

export function sortFileProvidersViewState(providers: FileProviderViewState[]) {
    const filteredProviders = providers
        .filter(p => p.type !== AttachmentDataProviderType.Mailbox)
        .filter(p => p.type !== AttachmentDataProviderType.MailMessage)
        .filter(p => !p.associatedWithPrimaryProvider);
    const primaryProviders = filteredProviders.filter(p => p.isPrimaryProvider);
    const followingPrimaryProviders = providers.filter(p => p.associatedWithPrimaryProvider);
    const alphabeticallySortedSecondaryProviders = filteredProviders
        .filter(p => !p.isPrimaryProvider)
        .sort((a, b) => a.name.localeCompare(b.name));

    // The mailbox provider is placed second to the end
    const mailboxProvider = providers.filter(p => p.type === AttachmentDataProviderType.Mailbox);

    // Mail Messages provider is placed at the end
    const mailMessageProvider = providers.filter(
        p => p.type === AttachmentDataProviderType.MailMessage
    );

    return primaryProviders
        .concat(followingPrimaryProviders)
        .concat(alphabeticallySortedSecondaryProviders)
        .concat(mailboxProvider)
        .concat(mailMessageProvider);
}
